import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);

export const getStaticDataProofOfAddressDocumentTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromProofOfAddressDocumentTypesReducer.proofOfAddressDocumentTypesFeatureKey]
);

export const getStaticDataProofOfAddressDocumentTypesFailure = createSelector(
  getStaticDataProofOfAddressDocumentTypesState,
  staticDataCountriesReducer.fromProofOfAddressDocumentTypesReducer.getProofOfAddressDocumentTypesError
);

export const getStaticDataProofOfAddressDocumentTypesResponse = createSelector(
  getStaticDataProofOfAddressDocumentTypesState,
  staticDataCountriesReducer.fromProofOfAddressDocumentTypesReducer.getProofOfAddressDocumentTypes
);
